<template>
    <div class="login-authentication">
        <svg class="logo" width="146" height="30" viewBox="0 0 146 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1754_13280)"><path d="M1.714 13.286v3.428m5.143-5.143v6.858M12 13.286v3.428m5.143-6.857v10.286m5.143-15.429v20.572m5.142-13.715v6.858m5.143-5.143v3.428" stroke="#2779ED" stroke-width="2.571" stroke-linecap="round" stroke-linejoin="round"/></g><path d="M45.036 21V4.2H55.14v1.968h-8.016v5.16h5.304v1.968h-5.304V21h-2.088zm16.858.288c-1.68 0-3.004-.572-3.972-1.716-.968-1.152-1.452-2.716-1.452-4.692 0-1.32.22-2.46.66-3.42.44-.96 1.064-1.7 1.872-2.22.816-.528 1.78-.792 2.892-.792 1.12 0 2.084.26 2.892.78.816.512 1.44 1.248 1.872 2.208.44.96.66 2.1.66 3.42 0 1.32-.22 2.464-.66 3.432-.44.96-1.068 1.7-1.884 2.22-.808.52-1.768.78-2.88.78zm0-1.944c1.032 0 1.84-.396 2.424-1.188.592-.8.888-1.9.888-3.3 0-1.408-.296-2.508-.888-3.3-.584-.792-1.392-1.188-2.424-1.188-1.04 0-1.852.396-2.436 1.188-.584.784-.876 1.892-.876 3.324 0 1.4.292 2.496.876 3.288.584.784 1.396 1.176 2.436 1.176zM71.416 21V8.736h2.088v1.248c.376-.52.828-.904 1.356-1.152.528-.256 1.132-.384 1.812-.384 1.488 0 2.592.452 3.312 1.356.72.896 1.08 2.276 1.08 4.14V21h-2.088v-7.416c0-1.032-.232-1.824-.696-2.376-.456-.56-1.104-.84-1.944-.84-.936 0-1.644.268-2.124.804-.472.528-.708 1.316-.708 2.364V21h-2.088zm19.563.288c-1.12 0-2.088-.276-2.904-.828-.816-.552-1.444-1.312-1.884-2.28-.44-.968-.66-2.076-.66-3.324 0-1.352.228-2.504.684-3.456.456-.96 1.092-1.692 1.908-2.196.816-.504 1.768-.756 2.856-.756.92 0 1.764.208 2.532.624.768.408 1.38 1.044 1.836 1.908.464.856.696 1.956.696 3.3 0 .192-.008.416-.024.672-.008.248-.024.504-.048.768h-8.304c.08.744.264 1.396.552 1.956.288.56.668 1 1.14 1.32.472.312 1.028.468 1.668.468.52 0 1-.092 1.44-.276a3.816 3.816 0 001.248-.852l1.224 1.368c-.456.456-1.024.836-1.704 1.14-.672.296-1.424.444-2.256.444zm-3.336-7.392h6.288c0-.696-.116-1.316-.348-1.86-.224-.552-.556-.984-.996-1.296-.44-.312-.976-.468-1.608-.468-.888 0-1.652.288-2.292.864-.632.576-.98 1.496-1.044 2.76zm15.656 7.392c-.84 0-1.484-.252-1.932-.756-.44-.504-.66-1.228-.66-2.172v-7.8h-1.992V8.736h1.992V4.68l2.088-1.008v5.064h3.024v1.824h-3.024v7.104c0 .584.1 1.012.3 1.284.208.264.532.396.972.396.56 0 1.168-.216 1.824-.648l-.24 2.04c-.36.192-.736.332-1.128.42a5.468 5.468 0 01-1.224.132zm10.357 0c-1.512 0-2.636-.448-3.372-1.344-.728-.896-1.092-2.272-1.092-4.128v-7.08h2.088v7.392c0 1.04.228 1.836.684 2.388.456.552 1.108.828 1.956.828.936 0 1.64-.268 2.112-.804.48-.536.72-1.324.72-2.364v-7.44h2.088V21h-2.088v-1.176c-.392.504-.836.876-1.332 1.116-.488.232-1.076.348-1.764.348zM123.959 21V8.736h2.088v1.608c.28-.624.664-1.096 1.152-1.416.496-.32 1.08-.48 1.752-.48.744 0 1.376.208 1.896.624l-.312 1.968a2.714 2.714 0 00-.828-.396 3.07 3.07 0 00-.924-.132c-.552 0-1.032.148-1.44.444-.408.296-.728.712-.96 1.248-.224.536-.336 1.164-.336 1.884V21h-2.088zm10.171 0V4.656l2.088-.984v9.288l3.984-4.224h2.496l-3.216 3.336L144.09 21h-2.28l-3.792-7.416-1.8 1.872V21h-2.088z" fill="#2779ED"/><defs><clipPath id="clip0_1754_13280"><path fill="#fff" transform="translate(0 3)" d="M0 0h34.286v24H0z"/></clipPath></defs></svg>
        <button
            class="btn-show-introduction"
            @click="emitShowLoginIntrudction">
            <span class="btn-show-introduction__icon"></span>
            <span class="btn-show-introduction__text">Ana Sayfa</span>
        </button>
        <div class="authentication-type-buttons">
            <button
                class="btn-show-login-form btn-authentication-type"
                :class="{'btn-authentication-type--active': show.loginForm || show.passwordResetRequestForm || show.passwordResetRequestSuccess}"
                @click="showLoginForm">
                <span class="btn-show-login-form__text btn-authentication-type__text">Giriş</span>
            </button>
            <button
                class="btn-show-signup-form btn-authentication-type"
                :class="{'btn-authentication-type--active': show.signupForm}"
                @click="showSignupForm">
                <span class="btn-show-signup-form__text btn-authentication-type__text">Üye Ol</span>
            </button>
        </div>

        <button class="btn-google-authentication" v-if="false">
            <span class="btn-google-authentication__icon"></span>
            <span class="btn-google-authentication__text">{{ textBtnGoogleAuth }}</span>
        </button>

        <form
            class="authentication-form authentication-form--login"
            v-if="show.loginForm">
            <h2 class="authentication-form__heading">Giriş Yap</h2>
            <span class="authentication-form__art-separator"></span>

            <div
                class="input-group"
                :class="{'input-group--error': css.loginUserError}">
                <label class="input-group__label" for="username">Kullanıcı Adı</label>
                <input
                    class="input-group__input input-group--input-username" id="username" type="text"
                    :value="$store.state.input.login.loginUser"
                    @input="inputLoginUser"
                    @keyup.enter="$store.state.envDev ? submitLoginForm() : submitLoginFormApi()">
                <span class="input-group__error-message">{{ errorMessage.loginUser }}</span>
            </div>

            <div
                class="input-group"
                :class="{'input-group--error': css.loginPassError}"
                v-if="!show.passwordValue">
                <label class="input-group__label" for="password">Şifre</label>
                <input
                    class="input-group__input input-group--input-pass" id="password" type="password"
                    :value="$store.state.input.login.loginPass"
                    @input="inputLoginPass"
                    @keyup.enter="$store.state.envDev ? submitLoginForm() : submitLoginFormApi()">
                <button
                    class="btn-show-password" type="button"
                    @click="showPasswordValue"></button>
                <span class="input-group__error-message">{{ errorMessage.loginPass }}</span>
            </div>

            <div
                class="input-group"
                :class="{'input-group--error': css.loginPassError}"
                v-if="show.passwordValue">
                <label class="input-group__label" for="password">Şifre</label>
                <input
                    class="input-group__input input-group--input-pass" id="password" type="text"
                    :value="$store.state.input.login.loginPass"
                    @input="inputLoginPass"
                    @keyup.enter="$store.state.envDev ? submitLoginForm() : submitLoginFormApi()">
                <button
                    class="btn-hide-password" type="button"
                    @click="hidePasswordValue"></button>
                <span class="input-group__error-message">{{ errorMessage.loginPass }}</span>
            </div>

            <div class="authentication-form-buttons">
                <button
                    class="btn-forgot-password" type="button"
                    @click="showPasswordResetRequestForm">
                    <span class="btn-forgot-password__text">Şifremi Unuttum</span>
                </button>
                <button
                    class="btn-confirm" type="button"
                    @click="$store.state.envDev ? submitLoginForm() : submitLoginFormApi()">
                    <span class="btn-confirm__text">Onayla</span>
                </button>
            </div>

            <div
                class="preloader"
                v-if="show.loginFormPreloader">
                <span class="preloader__icon"></span>
                <p class="preloader__text">Yükleniyor...</p>                
            </div>
        </form>

        <form
            class="authentication-form authentication-form--signup"
            v-if="show.signupForm">
            <h2 class="authentication-form__heading">Üye Ol</h2>
            <span class="authentication-form__art-separator"></span>

            <div
                class="input-group"
                :class="{'input-group--error': css.signupUserError}">
                <label class="input-group__label" for="username">Kullanıcı Adı</label>
                <input
                    class="input-group__input input-group--input-username" id="username" type="text"
                    :value="$store.state.input.login.signupUser"
                    @input="inputSignupUser"
                    @keyup.enter="$store.state.envDev ? submitSignupForm() : submitSignupFormApi()">
                <span class="input-group__error-message">{{ errorMessage.signupUser }}</span>
            </div>

            <div
                class="input-group"
                :class="{'input-group--error': css.signupEmailError}">
                <label class="input-group__label" for="email">Email</label>
                <input
                    class="input-group__input input-group--input-email" id="email" type="text"
                    :value="$store.state.input.login.signupEmail"
                    @input="inputSignupEmail"
                    @keyup.enter="$store.state.envDev ? submitSignupForm() : submitSignupFormApi()">
                <span class="input-group__error-message">{{ errorMessage.signupEmail }}</span>
            </div>

            <div
                class="input-group"
                :class="{'input-group--error': css.signupPassError}"
                v-if="!show.signupPasswordValue">
                <label class="input-group__label" for="password">Şifre</label>
                <input
                    class="input-group__input input-group--input-pass" id="password" type="password"
                    :value="$store.state.input.login.signupPass"
                    @input="inputSignupPass"
                    @keyup.enter="$store.state.envDev ? submitSignupForm() : submitSignupFormApi()">
                <button
                    class="btn-show-password" type="button"
                    @click="showSignupPasswordValue"></button>
                <span class="input-group__error-message">{{ errorMessage.signupPass }}</span>
            </div>

            <div
                class="input-group"
                :class="{'input-group--error': css.signupPassError}"
                v-if="show.signupPasswordValue">
                <label class="input-group__label" for="password">Şifre</label>
                <input
                    class="input-group__input input-group--input-pass" id="password" type="text"
                    :value="$store.state.input.login.signupPass"
                    @input="inputSignupPass"
                    @keyup.enter="$store.state.envDev ? submitSignupForm() : submitSignupFormApi()">
                <button
                    class="btn-hide-password" type="button"
                    @click="hideSignupPasswordValue"></button>
                <span class="input-group__error-message">{{ errorMessage.signupPass }}</span>
            </div>

            <div class="authentication-form-buttons">
                <button
                    class="btn-confirm" type="button"
                    @click="$store.state.envDev ? submitSignupForm() : submitSignupFormApi()">
                    <span class="btn-confirm__text">Onayla</span>
                </button>
            </div>

            <div
                class="preloader"
                v-if="show.signupFormPreloader">
                <span class="preloader__icon"></span>
                <p class="preloader__text">Yükleniyor...</p>                
            </div>
        </form>

        <form
            class="authentication-form authentication-form--password-reset-request"
            v-if="show.passwordResetRequestForm">
            <h2 class="authentication-form__heading">Şifre Sıfırlama İsteği</h2>
            <p class="authentication-form__text">Hesabının mailini girerek bir şifre sıfırlama bağlantısı talep edebilirsin.</p>
            <span class="authentication-form__art-separator"></span>

            <div
                class="input-group"
                :class="{'input-group--error': css.passwordResetRequestEmailError}">
                <label class="input-group__label" for="email">Email</label>
                <input
                    class="input-group__input input-group--input-email" id="email" type="text"
                    :value="$store.state.input.login.passwordResetRequestEmail"
                    @input="inputPasswordResetRequestEmail">
                <span class="input-group__error-message">{{ errorMessage.passwordResetRequestEmail }}</span>
            </div>

            <div class="authentication-form-buttons">
                <button
                    class="btn-confirm" type="button"
                    @click="$store.state.envDev ? submitPasswordResetRequestForm() : submitPasswordResetRequestFormApi()">
                    <span class="btn-confirm__text">Onayla</span>
                </button>
            </div>

            <div
                class="preloader"
                v-if="show.passwordResetRequestFormPreloader">
                <span class="preloader__icon"></span>
                <p class="preloader__text">Yükleniyor...</p>                
            </div>
        </form>

        <div
            class="form-notification"
            v-if="show.passwordResetRequestSuccess">
            <h2 class="form-notification__heading">Şifre Sıfırlama İsteği</h2>
            <p class="form-notification__text">Hesabının mailini girerek bir şifre sıfırlama bağlantısı talep edebilirsin.</p>
            <span class="form-notification__art-separator"></span>

            <h3 class="form-notification__heading--small">Şifre Sıfırlama</h3>
            <p class="form-notification__text">{{ $store.state.input.login.passwordResetRequestEmail }} adresine gelen bağlantıyı kullanarak şifreni sıfırlayabilirsin.</p>

            <div class="form-result">
                <svg class="form-result__icon" width="51" height="47" viewBox="0 0 51 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1815_2934)" fill="#AED0DF"><path d="M10.184 23.782c-.251 2.51.753 4.769 2.259 6.526l8.031 8.031c1.506 1.506 3.514 2.51 5.773 2.51s4.266-.753 5.772-2.51l16.063-16.063c1.506-1.506 2.51-3.513 2.51-5.772 0-2.259-.753-4.267-2.51-5.773L40.051 2.7C38.294.943 36.035.19 33.525.44c-2.008.251-3.765 1.004-5.02 2.259L12.695 18.763c-1.506 1.255-2.26 3.262-2.51 5.02zM30.764 7.72L29.51 17.759c-.25 1.255-1.003 2.008-2.258 2.259l-10.04 1.255L30.764 7.72zm-2.76 17.066c3.513-.502 6.274-3.012 6.525-6.525l1.506-12.298c.25 0 .25.25.502.25l8.031 8.032a3.181 3.181 0 010 4.518L28.506 34.825a3.181 3.181 0 01-4.518 0l-7.78-8.031c-.251-.25-.251-.502-.502-.502l12.298-1.506zM3.41 44.363c.752 0 1.254-.251 1.756-.753l7.53-7.53c1.003-1.003 1.003-2.51 0-3.513-1.004-1.004-2.51-1.004-3.514 0l-7.53 7.53c-1.004 1.003-1.004 2.509 0 3.513.502.502 1.004.753 1.757.753zM15.206 46.12l2.51-2.51c1.004-1.004 1.004-2.51 0-3.514s-2.51-1.004-3.514 0l-2.51 2.51c-1.004 1.004-1.004 2.51 0 3.514.502.502 1.004.752 1.757.752.753 0 1.255-.25 1.757-.752z"/></g><defs><clipPath id="clip0_1815_2934"><path fill="#fff" d="M0 0h51v47H0z"/></clipPath></defs></svg>
                <p class="form-result__heading">Mail Yolda</p>
                <p class="form-result__text">Şifre sıfırlama bağlantısını gönderdik.</p>
            </div>
        </div>

        <span class="login-authentication__art-bg-authentication"></span>
    </div>
</template>
<script>
    // Library imports.
    import validator from 'validator';

    export default {
        data(){
            return {
                show: {
                    loginForm:  true,
                    loginFormPreloader: false,

                    signupForm: false,
                    signupFormPreloader: false,

                    passwordResetRequestForm: false,
                    passwordResetRequestFormPreloader: false,
                    passwordResetRequestSuccess: false,

                    passwordValue: false,
                    signupPasswordValue: false,
                },
                css: {
                    loginUserError: false,
                    loginPassError: false,

                    signupUserError:  false,
                    signupEmailError: false,
                    signupPassError:  false,

                    passwordResetRequestEmailError: false,
                },
                errorMessage: {
                    loginUser: '',
                    loginPass: '',

                    signupUser: '',
                    signupEmail: '',
                    signupPass: '',

                    passwordResetRequestEmail: '',
                },
                abortController: {
                    login:  null,
                    signup: null,
                    passwordResetRequest: null,
                },
            };
        },

        computed: {
            textBtnGoogleAuth(){
                return this.show.loginForm || this.show.passwordResetRequestForm ? 'Google ile oturum aç' : 'Google ile üye ol';
            },
        },

        methods: {
            emitShowLoginIntrudction(){
                this.$emit('showLoginIntroduction');

                // Abort all requests.
                if(this.abortController.login){
                    this.abortController.login.abort("LOGIN_AUTHENTICATION/EMIT_SHOW_LOGIN_INTRODUCTION::LOGIN_REQUEST_ABORTED");
                }
                if(this.abortController.signup){
                    this.abortController.signup.abort("LOGIN_AUTHENTICATION/EMIT_SHOW_LOGIN_INTRODUCTION::SIGNUP_REQUEST_ABORTED");
                }
                if(this.abortController.passwordResetRequest){
                    this.abortController.passwordResetRequest.abort("LOGIN_AUTHENTICATION/EMIT_SHOW_LOGIN_INTRODUCTION::PASSWORD_RESET_REQUEST_REQUEST_ABORTED");
                }
            },

            showLoginForm(){
                this.show.passwordResetRequestForm    = false;
                this.show.passwordResetRequestSuccess = false;
                this.show.signupForm = false;
                this.show.loginForm  = true;
                if(this.abortController.signup){
                    this.abortController.signup.abort("LOGIN_AUTHENTICATION/SHOW_LOGIN_FORM::SIGNUP_REQUEST_ABORTED");
                }
                if(this.abortController.passwordResetRequest){
                    this.abortController.passwordResetRequest.abort("LOGIN_AUTHENTICATION/SHOW_LOGIN_FORM::PASSWORD_RESET_REQUEST_REQUEST_ABORTED");
                }
            },

            showSignupForm(){
                this.show.passwordResetRequestForm    = false;
                this.show.passwordResetRequestSuccess = false;
                this.show.loginForm = false;
                this.show.signupForm = true;
                if(this.abortController.login){
                    this.abortController.login.abort("LOGIN_AUTHENTICATION/SHOW_SIGNUP_FORM::LOGIN_REQUEST_ABORTED");
                }
                if(this.abortController.passwordResetRequest){
                    this.abortController.passwordResetRequest.abort("LOGIN_AUTHENTICATION/SHOW_SIGNUP_FORM::PASSWORD_RESET_REQUEST_REQUEST_ABORTED");
                }
            },

            showPasswordResetRequestForm(){
                this.show.loginForm  = false;
                this.show.signupForm = false;
                this.show.passwordResetRequestForm = true;
            },

            showPasswordValue(event){
                this.show.passwordValue = true;
            },

            hidePasswordValue(event){
                this.show.passwordValue = false;
            },

            showSignupPasswordValue(event){
                this.show.signupPasswordValue = true;
            },

            hideSignupPasswordValue(event){
                this.show.signupPasswordValue = false;
            },

            inputLoginUser(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'login',
                    dataLabel: 'loginUser',
                    data: event.target.value
                });
            },

            inputLoginPass(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'login',
                    dataLabel: 'loginPass',
                    data: event.target.value
                });
            },

            validateLoginForm(){
                // Disable error classes and messages from earlier attempts.
                this.css.loginUserError = false;
                this.errorMessage.loginUser = '';

                this.css.loginPassError = false;
                this.errorMessage.loginPass = '';

                // Validate username length.
                let minLength = this.$store.state.validation.minLength.login.user;
                if(this.$store.state.input.login.loginUser.length < minLength){
                    this.css.loginUserError = true;
                    this.errorMessage.loginUser = `En az ${minLength} karakter.`;
                    this.$foneturkError({
                        text: `Kullanıcı adın en az ${minLength} karakterden oluşmalı.`
                    });
                    return false;
                }

                let maxLength = this.$store.state.validation.maxLength.login.user;
                if(this.$store.state.input.login.loginUser.length > maxLength){
                    this.css.loginUserError = true;
                    this.errorMessage.loginUser = `En fazla ${maxLength} karakter.`;
                    this.$foneturkError({
                        text: `Kullanıcı adın en fazla ${maxLength} karakterden oluşabilir.`
                    });
                    return false;
                }

                // Validate username pattern.
                let pattern = this.$store.state.validation.pattern.login.user;
                if(!pattern.test(this.$store.state.input.login.loginUser)){
                    this.css.loginUserError = true;
                    this.errorMessage.loginUser = 'Yalnızca harf ve sayıdan oluşmalı.';
                    this.$foneturkError({
                        text: 'Kullanıcı adın yalnızca harf ve sayıdan oluşmalı.'
                    });
                    return false;
                }

                // Validate password length.
                minLength = this.$store.state.validation.minLength.login.pass;
                if(this.$store.state.input.login.loginPass.length < minLength){
                    this.css.loginPassError = true;
                    this.errorMessage.loginPass = `En az ${minLength} karakter.`;
                    this.$foneturkError({
                        text: `Şifren en az ${minLength} karakterden oluşmalı.`
                    });
                    return false;
                }

                return true;
            },

            submitLoginForm(event){
                // Validate form.
                if(!this.validateLoginForm()){
                    return;
                }

                // Show preloader.
                this.show.loginFormPreloader = true;

                // Send request.
                this.abortController.login = new AbortController();
                fetch(this.$store.state.jsonServer.login, {
                    signal: this.abortController.login.signal,
                })
                .then(response => {
                    this.show.loginFormPreloader = false;
                    return response.json();
                })
                .then(loginData => {
                    this.$store.commit('setUserSession', loginData.userSession);
                    this.$router.push('/practice-modes');
                })
                .catch(err => {
                    this.show.loginFormPreloader = false;
                    console.error(err);
                });
            },

            submitLoginFormApi(event){
                // Validate form.
                if(!this.validateLoginForm()){
                    return;
                }

                // Show preloader.
                this.show.loginFormPreloader = true;

                // Prepare request body.
                let loginCredentials = {
                    user: this.$store.state.input.login.loginUser,
                    pass: this.$store.state.input.login.loginPass,
                };

                // Send request.
                this.abortController.login = new AbortController();
                fetch(this.$store.state.api.login, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    credentials: 'include',
                    signal: this.abortController.login.signal,
                    body: `loginCredentials=${JSON.stringify(loginCredentials)}`,
                })
                .then(async response => {
                    this.show.loginFormPreloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(loginData => {
                    this.$store.commit('setUserSession', loginData.userSession);
                    this.$router.push('/practice-modes');
                })
                .catch(err => {
                    this.show.loginFormPreloader = false;
                    console.error(err);
                    if(err.code == 'LOGIN_MODEL/RUN::USER_NOT_FOUND'){
                        this.css.loginUserError = true;
                        this.errorMessage.loginUser = 'Kullanıcı yok.';
                        this.$foneturkError({
                            text: 'Girdiğin isme sahip bir kullanıcı yok.'
                        });
                    }
                    else if(err.code == 'LOGIN_MODEL/RUN::INCORRECT_PASSWORD'){
                        this.css.loginPassError = true;
                        this.errorMessage.loginPass = 'Şifre yanlış.';
                        this.$foneturkError({
                            text: 'Girdiğin şifre yanlış.'
                        });
                    }
                    else if(err == 'LOGIN_AUTHENTICATION/EMIT_SHOW_LOGIN_INTRODUCTION::LOGIN_REQUEST_ABORTED' ||
                            err == 'LOGIN_AUTHENTICATION/SHOW_SIGNUP_FORM::LOGIN_REQUEST_ABORTED'){
                        
                    }
                    else{
                        this.$foneturkError({
                            text: 'Bir şeyler ters gitti.'
                        });
                    }
                });
            },

            inputSignupUser(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'login',
                    dataLabel: 'signupUser',
                    data: event.target.value
                });
            },

            inputSignupEmail(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'login',
                    dataLabel: 'signupEmail',
                    data: event.target.value
                });
            },

            inputSignupPass(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'login',
                    dataLabel: 'signupPass',
                    data: event.target.value
                });
            },

            validateSignupForm(){
                // Disable error classes and messages from earlier attempts.
                this.css.signupUserError = false;
                this.errorMessage.signupUser = '';

                this.css.signupEmailError = false;
                this.errorMessage.signupEmail = '';

                this.css.signupPassError = false;
                this.errorMessage.signupPass = '';

                // Validate username length.
                let minLength = this.$store.state.validation.minLength.login.user;
                if(this.$store.state.input.login.signupUser.length < minLength){
                    this.css.signupUserError = true;
                    this.errorMessage.signupUser = `En az ${minLength} karakter.`;
                    this.$foneturkError({
                        text: `Kullanıcı adın en az ${minLength} karakterden oluşmalı.`
                    });
                    return false;
                }

                let maxLength = this.$store.state.validation.maxLength.login.user;
                if(this.$store.state.input.login.signupUser.length > maxLength){
                    this.css.signupUserError = true;
                    this.errorMessage.signupUser = `En fazla ${maxLength} karakter.`;
                    this.$foneturkError({
                        text: `Kullanıcı adın en fazla ${maxLength} karakterden oluşabilir.`
                    });
                    return false;
                }

                // Validate username pattern.
                let pattern = this.$store.state.validation.pattern.login.user;
                if(!pattern.test(this.$store.state.input.login.signupUser)){
                    this.css.signupUserError = true;
                    this.errorMessage.signupUser = 'Yalnızca harf ve sayıdan oluşmalı.';
                    this.$foneturkError({
                        text: 'Kullanıcı adın yalnızca harf ve sayıdan oluşmalı.'
                    });
                    return false;
                }

                // Validate email.
                if(!validator.isEmail(this.$store.state.input.login.signupEmail)){
                    this.css.signupEmailError = true;
                    this.errorMessage.signupEmail = 'Email adresi geçersiz.';
                    this.$foneturkError({
                        text: 'Geçersiz bir mail adresi girdin.'
                    });
                    return false;
                }

                // Validate password length.
                minLength = this.$store.state.validation.minLength.login.pass;
                if(this.$store.state.input.login.signupPass.length < minLength){
                    this.css.signupPassError = true;
                    this.errorMessage.signupPass = `En az ${minLength} karakter.`;
                    this.$foneturkError({
                        text: `Şifren en az ${minLength} karakterden oluşmalı.`
                    });
                    return false;
                }

                return true;
            },


            submitSignupForm(event){
                // Validate signup form.
                if(!this.validateSignupForm()){
                    return;
                }

                // Show preloader.
                this.show.signupFormPreloader = true;

                // Send request.
                this.abortController.signup = new AbortController();
                fetch(this.$store.state.jsonServer.signup, {
                    signal: this.abortController.signup.signal,
                })
                .then(response => {
                    this.show.signupFormPreloader = false;
                    return response.json();
                })
                .then(signupData => {
                    this.$store.commit('setUserSession', signupData.userSession);
                    this.$router.push('/practice-modes');
                })
                .catch(err => {
                    this.show.signupFormPreloader = false;
                    console.error(err);
                });
            },

            submitSignupFormApi(){
                // Validate signup form.
                if(!this.validateSignupForm()){
                    return;
                }

                // Show preloader.
                this.show.signupFormPreloader = true;

                // Prepare request body.
                let signupCredentials = {
                    user:  this.$store.state.input.login.signupUser,
                    email: this.$store.state.input.login.signupEmail,
                    pass:  this.$store.state.input.login.signupPass,
                };

                // Send request.
                this.abortController.signup = new AbortController();
                fetch(this.$store.state.api.signup, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    credentials: 'include',
                    signal: this.abortController.signup.signal,
                    body: `signupCredentials=${JSON.stringify(signupCredentials)}`,
                })
                .then(async response => {
                    this.show.signupFormPreloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(signupData => {
                    this.$store.commit('setUserSession', signupData.userSession);
                    this.$router.push('/practice-modes');
                })
                .catch(err => {
                    console.error(err);
                    if(err.code == 'SIGNUP_MODEL/RUN::USERNAME_EXISTS'){
                        this.css.signupUserError = true;
                        this.errorMessage.signupUser = 'Kullanıcı adı daha önce alınmış.';
                        this.$foneturkError({
                            text: 'Bu kullanıcı adı daha önce alınmış.',
                        });
                    }
                    else if(err.code == 'SIGNUP_MODEL/RUN::EMAIL_EXISTS'){
                        this.css.signupEmailError = true;
                        this.errorMessage.signupEmail = 'Email başka kullanıcıya ait.',
                        this.$foneturkError({
                            text: 'Bu email başka bir kullanıcı tarafından kullanılıyor.',
                        });
                    }
                    else if(err == 'LOGIN_AUTHENTICATION/EMIT_SHOW_LOGIN_INTRODUCTION::SIGNUP_REQUEST_ABORTED' ||
                            err == 'LOGIN_AUTHENTICATION/SHOW_LOGIN_FORM::SIGNUP_REQUEST_ABORTED'){
                        this.show.signupFormPreloader = false;
                    }
                    else{
                        this.$foneturkError({
                            text: 'Bir şeyler ters gitti.',
                        });
                    }
                })
            },

            inputPasswordResetRequestEmail(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'login',
                    dataLabel: 'passwordResetRequestEmail',
                    data: event.target.value
                });
            },

            validatePasswordResetRequestForm(){
                // Disable error classes and messages from earlier attempts.
                this.css.passwordResetRequestEmailError = false;
                this.errorMessage.passwordResetRequestEmail = '';

                // Validate email pattern.
                if(!validator.isEmail(this.$store.state.input.login.passwordResetRequestEmail)){
                    this.css.passwordResetRequestEmailError = true;
                    this.errorMessage.passwordResetRequestEmail = 'Email adresi geçersiz.';
                    this.$foneturkError({
                        text: 'Geçersiz bir mail adresi girdin.'
                    });
                    return false;
                }

                return true;
            },

            submitPasswordResetRequestForm(event){
                // Validate password reset request form.
                if(!this.validatePasswordResetRequestForm()){
                    return;
                }

                // Show preloader.
                this.show.passwordResetRequestFormPreloader = true;

                // Send request.
                this.abortController.passwordResetRequest = new AbortController();
                fetch(this.$store.state.jsonServer.passwordResetRequest, {
                    signal: this.abortController.passwordResetRequest.signal
                })
                .then(response => {
                    this.show.passwordResetRequestFormPreloader = false;
                    return response.json();
                })
                .then(passwordResetRequestData => {
                    console.log(passwordResetRequestData);
                    this.show.passwordResetRequestForm = false;
                    this.show.passwordResetRequestSuccess = true;
                })
                .catch(err => {
                    this.show.passwordResetRequestFormPreloader = false;
                    console.error(err);
                });
            },

            submitPasswordResetRequestFormApi(){
                // Validate password reset request form.
                if(!this.validatePasswordResetRequestForm()){
                    return;
                }

                // Show preloader.
                this.show.passwordResetRequestFormPreloader = true;

                // Prepare request body.
                let passwordResetRequestOptions = {
                    email: this.$store.state.input.login.passwordResetRequestEmail,
                };

                // Send request.
                this.abortController.passwordResetRequest = new AbortController();
                fetch(this.$store.state.api.requestPasswordReset, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    credentials: 'include',
                    signal: this.abortController.passwordResetRequest.signal,
                    body: `passwordResetRequestOptions=${JSON.stringify(passwordResetRequestOptions)}`,
                })
                .then(async response => {
                    this.show.passwordResetRequestFormPreloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(passwordResetRequestData => {
                    console.log(passwordResetRequestData);
                    this.show.passwordResetRequestForm    = false;
                    this.show.passwordResetRequestSuccess = true;
                })
                .catch(err => {
                    console.error(err);
                    if(err.code == 'REQUEST_PASSWORD_RESET_MODEL/RUN::USER_NOT_EXISTS'){
                        this.css.passwordResetRequestEmailError = true;
                        this.errorMessage.passwordResetRequestEmail = 'Emaile ait kullanıcı yok.';
                        this.$foneturkError({
                            text: 'Girdiğin maile ait bir kullanıcı yok.'
                        });
                    }
                    else if(err.code == 'REQUEST_PASSWORD_RESET_MODEL/RUN::MAIL_NOT_SENT'){
                        this.$foneturkError({
                            text: 'Bir sorun sebebiyle mail gönderilemedi, daha sonra dene.'
                        });
                    }
                    else if(err == 'LOGIN_AUTHENTICATION/EMIT_SHOW_LOGIN_INTRODUCTION::PASSWORD_RESET_REQUEST_REQUEST_ABORTED' ||
                            err == 'LOGIN_AUTHENTICATION/SHOW_LOGIN_FORM::PASSWORD_RESET_REQUEST_REQUEST_ABORTED' ||
                            err == 'LOGIN_AUTHENTICATION/SHOW_SIGNUP_FORM::PASSWORD_RESET_REQUEST_REQUEST_ABORTED'){
                        this.show.passwordResetRequestFormPreloader = false;
                    }
                    else{
                        this.$foneturkError({
                            text: 'Bir şeyler ters gitti.',
                        });
                    }
                });
            },
        },
    };
</script>
<style scoped src="@/css/components/login-authentication.css"></style>